import { PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function ErrorContent({ children }: PropsWithChildren) {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
      <Stack direction="column" alignItems="center">
        <Box ml={2}>
          <img
            src="/images/icons/cross.webp"
            alt="error"
            width={100}
            height={100}
          />
        </Box>
        <Typography
          variant="subtitle1"
          align="center"
          color="#4F4F4F"
          sx={{ lineHeight: "1.5em" }}>
          {children}
        </Typography>
      </Stack>
    </Box>
  );
}
